import React, {useEffect, useState} from 'react';
import Avatar from '@mui/material/Avatar';
import MaleAvatar from '../../../assets/MaleAvatar.png';
import FemaleAvatar from '../../../assets/FemaleAvatar.png';
import Storage from "@aws-amplify/storage";
import { getSignedUrl } from '../../auth/util/util';


function AvatarItem(props) {
    const [imageUrl, setImageUrl] = useState('');
    useEffect(()=>{
        getProfileImage()
        
    },[]);
    const getProfileImage = async()=> {
        if(props.item)
        {
            let content = JSON.parse(props.item.content);
            let uploaded_image= content.find(i=>i.uploaded_image);
            let icon = content.find(i=>i.icon)
            if(uploaded_image && uploaded_image.uploaded_image=='true')
            {
                let imageURL='';
                let result = await Storage.list('profileThumb/'+icon.icon)
                
                if(result.length>0)
                {
                    imageURL='profileThumb/'+icon.icon
                }
                else
                {
                    imageURL=icon.icon
                }
                
                await getSignedUrl(imageURL, {level: 'public'}).then(setImageUrl).catch(err => console.log(err));
                
            }
            else
            {
                if(icon)
                {
                    setImageUrl(icon.icon)
                }
                else
                {
                    setImageUrl(MaleAvatar)
                }
                
            }
        }

    }
  return (
    <><Avatar alt="Company Name" src={imageUrl} /></>
  )
}

export default AvatarItem